import * as angular from 'angular';

import { Alias, AliasBinding } from '../../models';
import { IRequestService } from '../request.service';

export interface IAliasService {
    getCustom(): angular.IPromise<Alias[]>;
    getDefault(): angular.IPromise<Alias[]>;
    add(aliases: Alias[]): angular.IPromise<Alias[]>;
    update(selectedItem): angular.IPromise<any>;
    deleteItem(guid: string): angular.IPromise<any>;
    deleteItems(guids: string[]): angular.IPromise<Alias[]>;
    updateList(modified: any[]): angular.IPromise<any>;
    getBindings(): angular.IPromise<AliasBinding[]>;
    updateBindings(toAdd: AliasBinding[], toDelete?: AliasBinding[]): angular.IPromise<void>;
}

export class AliasService implements IAliasService {
    static $inject = ['$q', 'requestService'];
    static serviceId = 'aliasService';

    constructor(private _q: angular.IQService,
        private _requestService: IRequestService) {
    }

    private controllerUrl() {
        return `${this._requestService.getUrlV1()}alias`;
    }

    getCustom() {
        return this._requestService.get(this.controllerUrl());
    }
    getDefault() {
        return this._requestService.get(`${this.controllerUrl()}/default`);
    }

    add(aliases: Alias[]): angular.IPromise<Alias[]> {
        return this._requestService.post(`${this.controllerUrl()}/add`, aliases)
        .then(data => {
            this._requestService.cleanCache(this.controllerUrl());
            return data;
        });
    }
    deleteItems(guids: string[]): angular.IPromise<any> {
        return this._requestService.delete(`${this.controllerUrl()}/delete`, guids)
            .then(data => {
                this._requestService.cleanCache(this.controllerUrl());
                return data;
            });
    }

    update(selectedItem): angular.IPromise<any> {
        const defered = this._q.defer();
        const url = `${this.controllerUrl()}/updateOne`;
        this._requestService.post(url, selectedItem)
            .then((data) => {
                this._requestService.cleanCache(this.controllerUrl());
                defered.resolve(data);
            })
            .catch((reason) => {
                defered.reject(reason);
            });
        return defered.promise;
    }

    updateList(modified: any[]): angular.IPromise<any> {
        const defered = this._q.defer();
        const url = `${this.controllerUrl()}/update`;
        this._requestService.post(url, modified)
            .then((data) => {
                this._requestService.cleanCache(this.controllerUrl());
                defered.resolve(data);
            })
            .catch((reason) => {
                defered.reject(reason);
            });
        return defered.promise;
    }

    deleteItem(guid: string): angular.IPromise<any> {
        const defered = this._q.defer();
        const url = `${this.controllerUrl()}/delete/${guid}`;
        this._requestService.delete(url)
            .then((data) => {
                this._requestService.cleanCache(this.controllerUrl());
                defered.resolve(data);
            })
            .catch((reason) => {
                defered.reject(reason);
            });
        return defered.promise;
    }

    getBindings(): angular.IPromise<AliasBinding[]> {
        const url = `${this.controllerUrl()}/bindings`;
        return this._requestService.get(url);
    }

    updateBindings(toAdd: AliasBinding[], toDelete?: AliasBinding[]): angular.IPromise<void> {
        const url = `${this.controllerUrl()}/bindings`;
        const data = { toUpdate: toAdd, toDelete: toDelete };
        return this._requestService.post(url, data).then(() => {
            this._requestService.cleanCache(url);
            this._requestService.cleanCacheAtV1('viewModel/all');
            this._requestService.cleanCacheAtV1('viewModel/guidList');
        });
    }
}